import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKey1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="key-1, password"><path d="M1.75 12C1.75 14.8995 4.10051 17.25 7 17.25C8.89118 17.25 10.5488 16.25 11.473 14.75H14L16 13.5L18 14.75H20.5L22.75 12L20.5 9.25H11.473C10.5488 7.74996 8.89118 6.75 7 6.75C4.10051 6.75 1.75 9.10051 1.75 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 12C7.75 12.4142 7.41421 12.75 7 12.75C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.5858 6.58579 11.25 7 11.25C7.41421 11.25 7.75 11.5858 7.75 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconKey1;
